import PropTypes from 'prop-types'
import React from 'react'
import ShowHide from 'ui/ShowHide'
import ActivityContextLink from './ActivityContextLink'

const ActivityLocation = props => (
  <div className='ActivityLocation'>
    {/* XXX: we can't link to deleted things */}
    <ShowHide show={!props.event.toLowerCase().match('deleted')}>
      <ActivityContextLink type={props.type} properties={props.properties} />
    </ShowHide>
  </div>
)

ActivityLocation.displayName = 'ActivityLocation'

ActivityLocation.propTypes = {
  event: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  properties: PropTypes.object.isRequired
}

export default ActivityLocation



// WEBPACK FOOTER //
// ./components/ActivityLocation.js